<template>
    <div class="action-logic-comp-wrap">
        <div class="content-sending">
            <span>发送以下内容给</span>
            <Select :initValue="sendTo" :options="sentToOptions" @menuClick="sendToChange" />
        </div>
        <div class="content-list">
            <div v-for="(item, index) in content" :key="item.uId" class="content-widget">
                <div class="widget-operator">
                    <span class="op-edit">
                        <i class="delete" @click="deleteWidget(item)"></i>
                    </span>
                    <span class="op-edit">
                        <i class="transfer" @mousedown="transPosition(...arguments, item)"></i>
                    </span>
                </div>
                <component
                    :is="item.wtType"
                    :value="item"
                    :widget="widget"
                    @change="itemChange($event, item)"
                    :rules="rules"
                    :validation="myValidation"
                />
            </div>
        </div>
        <SendActionMore class="more-answer" @add="addActionContent" />
    </div>
</template>

<script>
import SendActionMore from "./SendActionMore";
import TextInput from "@/views/zhiji/components/commonForm/widgets/TextInput";
import LinkTextInput from "@/views/zhiji/components/commonForm/widgets/LinkTextInput";
import QuestionForm from "@/views/zhiji/components/commonForm/widgets/QuestionForm";
import Select from "@/views/zhiji/bComponents/inputs/Select";
import { uniqueId, genIndexSearchHandler } from "@/views/zhiji/js/common/util.js";
import Validation from "@/views/zhiji/components/commonForm/validation.js";
import { stringRegExp } from "@/views/zhiji/components/commonForm/rules.js";

import i18n from "@/i18n";

const sentToOptions = [
    {
        label: "Customer",
        value: "reply"
    }
];

function initTextInput() {
    return {
        linkWord: [],
        text: "",
        uId: uniqueId(),
        updateState: "add",
        wtType: "LinkTextInput"
    };
}
function initActionForm() {
    return {
        title: "",
        uId: uniqueId(),
        updateState: "add",
        wtType: "QuestionForm"
    };
}

export default {
    name: "SendAction",
    components: {
        SendActionMore,
        LinkTextInput,
        TextInput,
        QuestionForm,
        Select
    },
    props: ["value"],
    data() {
        return {
            sendTo: "reply",
            sentToOptions,
            content: this.value || [],
            rules: [
                {
                    required: true
                },
                {
                    regExp: /<|>/,
                    validator: stringRegExp,
                    message: "名称不可携带<>,会有xss安全风险"
                }
            ],
            widget: {
                props: {
                    hiddenBtns: {
                        portrait: true
                    }
                }
            },
            myValidation: null
        };
    },
    watch: {
        value(newVal) {
            this.content = newVal;
        }
    },
    async created() {
        this.myValidation = new Validation();
    },
    destroyed() {
        this.myValidation && this.myValidation.destroy();
    },
    mounted() {
        if (this.content.length === 0) {
            this.content.push(initTextInput());
        }
    },
    methods: {
        deleteWidget(data) {
            this.$store.dispatch("zhiji/showModal", {
                type: "MessageModal",
                data: {
                    type: "tip",
                    message: i18n.t("zhiji.answer.deleteWidgetTip"),
                    confirm: () => {
                        this.deleteActionContent({ ...data });
                    }
                }
            });
        },
        transPosition(event, data) {
            this.zhiji.dragStart(event, "content-widget", "v", newIdx => {
                this.transferActionContent({
                    newIdx: newIdx,
                    uId: data.uId
                });
            });
        },
        itemChange(data, oldData) {
            this.updateActionContent({ ...oldData, ...data });
        },
        addActionContent(data) {
            const initMap = {
                QuestionForm: initActionForm,
                LinkTextInput: initTextInput
            };
            this.content.push(initMap[data.wtType]());
            this.emitChange();
        },
        // 更新组件
        updateActionContent(data) {
            const idx = genIndexSearchHandler("uId")(this.content, data.uId);
            const oldItem = this.content[idx];
            this.content.splice(idx, 1, Object.assign({}, oldItem, data));
            this.emitChange();
        },
        // 删除组件
        deleteActionContent(data) {
            const idx = genIndexSearchHandler("uId")(this.content, data.uId);
            this.content.splice(idx, 1);
            this.emitChange();
        },
        // 移动组件
        transferActionContent(data) {
            const idx = genIndexSearchHandler("uId")(this.content, data.uId);
            const oldItem = this.content[idx];
            if (data.newIdx < 0 || data.newIdx === idx) {
                return;
            }
            this.content.splice(idx, 1);
            this.content.splice(data.newIdx, 0, oldItem);
            this.emitChange();
        },
        emitChange() {
            this.$emit("change", this.content);
        },
        sendToChange(option) {
            this.sendTo = option.value;
        },
        async validate() {
            const { isValid } = await this.myValidation.validate();
            return isValid;
        }
    }
};
</script>

<style lang="less" scoped>
@import (reference) url("../common/rpaNode.less");
@contentWidth: 730px;

.action-logic-comp-wrap {
    border: 0.5px solid #d8e4f0;
    border-radius: 2px;
    margin-top: 12px;
    margin-bottom: 20px;
    width: @contentWidth;
    .content-list {
        position: relative;
        padding-top: 1px;
        padding-left: 15px;
        .content-widget {
            position: relative;
            display: flex;
            flex-direction: row;
            margin-left: 20px;
            margin-bottom: 25px;
            .widget-operator {
                display: inline-flex;
                flex-direction: column;
                margin-right: 10px;

                .op-edit {
                    .span-op();
                    margin-bottom: 8px;
                }

                .transfer {
                    width: 13px;
                    height: 18px;
                    vertical-align: middle;
                    background: url(/zhiji/images/class-spr.png);
                    background-position: -113px 0;
                    &:hover {
                        background-position: -113px -22px;
                    }
                }
            }
        }
    }
    .content-sending {
        height: 43px;
        padding: 10px 15px 5px 20px;
        background: #fbfcfd;
        .select-opt {
            margin-left: 10px;
            vertical-align: sub;
        }
    }
    .more-answer {
        margin-bottom: 25px;
    }
    .delete {
        width: 16px;
        height: 18px;
        background: url(/zhiji/images/class-spr.png);
        background-position: -96px 0;

        &:hover {
            background-position: -96px -22px;
        }
    }
}
</style>
